/**
 * Created by chenqifeng on 2016/8/31.
 */

import maple from 'maple';
import domain from '../domain';

let setCookie = function(key,value,time){
    var opt = {path:'/',domain:domain.tgDomain};
    if(time){
        opt.expires = time;
    }
    return maple.cookie(key,value,opt)
};

let getCookie = function(key){
    return maple.cookie(key);
};

let removeCookie = function(key){
    var opt = {path:'/',domain:domain.tgDomain};
    return maple.cookie.remove(key,opt);
};

export {setCookie,getCookie,removeCookie};

